import React from 'react'
import { buttonsVariants } from '@web/modules/message-preview/styles'
import { ChatSource } from '@repo/types'
import { Button } from '@tecsinapse/cortex-react'

interface TemplateButtonsProps {
  buttons: string[]
  source: ChatSource
  fullWidth?: boolean
}

const { buttonsStyle, buttonSource, buttonText, buttonContainer } = buttonsVariants()

const Buttons = ({ buttons, source, fullWidth = false }: TemplateButtonsProps) => (
  <div
    className={buttonsStyle({
      twoButtons: buttons.length <= 2,
      threeButtons: buttons.length > 2,
      fullWidth
    })}
  >
    {buttons.map(it => (
      <div
        className={buttonContainer()}
        key={it}
      >
        <Button
          className={buttonSource({ source })}
          variants={{
            size: 'small'
          }}
          disabled
        >
          <p className={buttonText({ source })}>{it}</p>
        </Button>
      </div>
    ))}
  </div>
)

export default Buttons
